import React from 'react'
import {
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  FormControlLabelProps,
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

import { AtLeast, ClassesType, Field } from '../../types'

const useStyles = makeStyles(
  theme => ({
    switchLabel: {
      color: theme.colors.secondaryText,
      fontSize: '1.6rem',
    },
    labelRoot: {},
  }),
  { name: 'PuiCheckbox' },
)

type CheckBoxField = AtLeast<Field, 'value' & 'set'>

export interface PuiCheckboxProps extends Omit<CheckboxProps, 'classes'> {
  readonly checkboxClasses?: CheckboxProps['classes']
  readonly classes?: ClassesType<typeof useStyles>
  readonly field?: CheckBoxField
  readonly label?: FormControlLabelProps['label']
  readonly labelProps?: Partial<FormControlLabelProps>
  readonly preferOnChangeProp?: boolean
}

const PuiCheckbox = ({
  label = '',
  className,
  checked: initialChecked,
  onChange: initialOnChange,
  field,
  labelProps: labelPropsProp,
  classes: classesProp,
  checkboxClasses,
  preferOnChangeProp,
  ...rest
}: PuiCheckboxProps) => {
  const labelProps = labelPropsProp || {}

  const classes = useStyles({ classes: classesProp })

  const checked = field?.value ?? initialChecked
  const onChange = preferOnChangeProp
    ? initialOnChange
    : (field?.set ?? initialOnChange)

  return (
    <FormControlLabel
      classes={{
        root: classes.labelRoot,
        label: classNames(className, classes.switchLabel),
      }}
      control={
        <Checkbox
          checked={checked}
          classes={checkboxClasses}
          onChange={onChange}
          {...rest}
        />
      }
      label={label}
      {...labelProps}
    />
  )
}

export default PuiCheckbox
